import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=b45c34ee&scoped=true"
var script = {}
import style0 from "./Routes.vue?vue&type=style&index=0&id=b45c34ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45c34ee",
  null
  
)

export default component.exports